"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyQuestionTable = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const react_query_1 = require("react-query");
const react_redux_1 = require("react-redux");
const styled_components_1 = __importStar(require("styled-components"));
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const server_1 = require("../../../../server");
const account_1 = require("../../../base/account");
const Survey_1 = require("../../../base/layout/Survey");
const DetailQuestionStyled = styled_components_1.default.div `
	& {
		padding-bottom: 20px;
	}

	.label {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--h5-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--h5-font-size, 16px);
		line-height: var(--h5-line-height, 24px);
		letter-spacing: var(--h5-letter-spacing, -0.02em);
		font-weight: var(--h5-font-weight, 700);
		position: relative;
		align-self: stretch;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
	${props => (props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	display: flex;
	flex-direction: column;
	gap: 12px;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	flex-shrink: 0;
	position: relative;
	height: 100%;

	/* .fext-field {
		height: 100%;
		overflow: hidden;
	} */

	.task-label {
		width: 100%;
	}

	.no-question-wrap {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: center;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		height: 100%;

		.fext-field {
			display: flex;
			flex-direction: column;
			gap: 8px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b1-font-family, 'Noto Sans KR', sans-serif);
				font-size: 18px;
				line-height: 150%;
				letter-spacing: -0.02em;
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}
	}

	.task-list-002 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;

		.table-header {
			width: 100%;
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 12px 0px 12px 0px;
			display: flex;
			flex-direction: column;
			gap: 6px;
			align-items: flex-start;
			justify-content: center;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			.input_answer_wrapper {
				background: #ffffff;
				border-radius: 4px;
				border-style: solid;
				border-color: var(--color-grey-w, #b6bac0);
				border-width: 1px;
				padding: 4px 10px 4px 10px;
				display: flex;
				flex-direction: row;
				gap: 6px;
				align-items: center;
				justify-content: center;
				flex-shrink: 0;
				position: relative;
				color: var(--color-grey-l, #83868a);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				font-weight: var(--b4-font-weight, 400);
				position: relative;
			}

			.body-item {
				width: 100%;
			}

			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 12px);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
		}
	}
	.input_point_wrapper {
		background: #ffffff;
		border-radius: 4px;
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px;
		padding: 10px;
		display: flex;
		flex-direction: row;
		gap: 6px;
		align-items: center;
		justify-content: center;
		position: relative;
		max-width: 80px;
		height: 38px;

		input {
			width: 100%;
			outline: none !important;
			border: none !important;
			padding: 0 !important;
			background: transparent;
		}
	}

	.detail_txt {
		color: var(--color-grey, #666666);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 16px;
		font-weight: 400;
		text-decoration: underline;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
	}

	.subject-item-wrap {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.subject-item-title {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 14px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 600;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	}

	.omr-point-wrap {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;
	}

	.submission-header {
		gap: 24px;
		width: 100%;
		display: flex;
		flex-direction: column;
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	gap: 21px;
	align-items: flex-end;
	justify-content: flex-start;
	align-self: stretch;
	flex: 1;
	position: relative;
	${props => props.$isDesktop &&
    props.$isTeacher &&
    `
		padding-top: 20px;
		border-top: 1px solid #e6e8ed;
	`}

	/* .fext-field {
		height: 100%;
		overflow: hidden;
	} */

	.task-label {
		width: 100%;
	}

	.no-question-wrap {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: center;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		height: 100%;

		.fext-field {
			display: flex;
			flex-direction: column;
			gap: 8px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b1-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b1-font-size, 20px);
				line-height: var(--b1-line-height, 42px);
				font-weight: var(--b1-font-weight, 400);
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}
	}

	.task-list-002 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.table-header {
			width: 100%;
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 8px 16px 8px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			.input_answer_wrapper {
				background: #ffffff;
				border-radius: 4px;
				border-style: solid;
				border-color: var(--color-grey-w, #b6bac0);
				border-width: 1px;
				padding: 4px 10px 4px 10px;
				display: flex;
				flex-direction: row;
				gap: 6px;
				align-items: center;
				justify-content: center;
				flex-shrink: 0;
				position: relative;
				color: var(--color-grey-l, #83868a);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				font-weight: var(--b4-font-weight, 400);
				position: relative;
			}

			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
		}
	}
	.input_point_wrapper {
		background: #ffffff;
		border-radius: 4px;
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px;
		padding: 4px 10px 4px 10px;
		display: flex;
		flex-direction: row;
		gap: 6px;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		position: relative;
		overflow: hidden;

		input {
			width: 100%;
			outline: none !important;
			border: none !important;
			padding: 0 !important;
			background: transparent;
		}
	}

	.detail_txt {
		color: var(--color-grey, #666666);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 16px;
		// line-height: 32px;
		font-weight: 400;
		text-decoration: underline;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
	}
`;
const count = 100;
exports.SurveyQuestionTable = react_1.default.memo(({ item, isTest, isSurvey = false, isSubmit, isOpen, test_id, answerData, }) => {
    const { isDesktop, isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const [surveyData, setSurveyData] = (0, react_1.useState)([]);
    const [changeSurveyData, setChangeSurveyData] = (0, react_1.useState)([]);
    const [submittedSurveyData, setSubmittedSurveyData] = (0, react_1.useState)([]);
    const submitAnswerMutation = (0, react_query_1.useMutation)(server_1.postSubmitAnswer);
    // 제출 진행 중 재진입 방지(더블클릭/이중 탭 이중 발사 차단) — 동기 ref 가드
    const isSubmittingRef = react_1.default.useRef(false);
    const { data, refetch } = (0, server_1.useQuestionList)({
        test_id,
        offset: 0,
        limit: 100,
        orderby: ['number'],
    });
    const throttledRefetch = (0, throttle_1.default)(refetch, 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        throttledRefetch();
    }, [test_id, isSubmit]);
    (0, react_1.useEffect)(() => {
        if (surveyData.length === 0)
            return;
        if (!isSubmit)
            return;
        if (answerData) {
            const { items } = answerData;
            const newSurveyData = surveyData.map(survey => {
                const answers = items.filter((a) => a.question_id === survey.id); // Filter answers for the current survey question
                if (answers.length > 0) {
                    if (survey.type === 'choice') {
                        const newSurvey = { ...survey };
                        newSurvey.data = survey.data.map(option => {
                            const selected = answers.some(answer => answer.value === option.title);
                            return { ...option, checked: selected };
                        });
                        return newSurvey;
                    }
                    else if (survey.type === 'checkbox') {
                        const newSurvey = { ...survey };
                        // For checkboxes, multiple answers can be checked
                        newSurvey.data = survey.data.map(option => {
                            const selected = answers.some(answer => answer.value === option.title);
                            return { ...option, checked: selected };
                        });
                        return newSurvey;
                    }
                    else {
                        // For other types, we just assign the single answer value
                        return { ...survey, data: answers[0].value };
                    }
                }
                return survey; // If no answer is found, return the survey unchanged
            });
            setSubmittedSurveyData(newSurveyData);
        }
    }, [answerData, isSubmit, surveyData]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { survey_questions } = item;
            const combinedArray = data.items.map(i => {
                const question = survey_questions[i.id];
                return {
                    id: i.id,
                    type: i.type,
                    title: question ? question.title : null,
                    data: question
                        ? question.options && question.options.length > 0
                            ? i.type == 'choice' || i.type == 'checkbox'
                                ? question.options.map((option, optionIndex) => ({
                                    id: `${i.id}-${optionIndex}`,
                                    title: option,
                                    checked: false,
                                }))
                                : ''
                            : ''
                        : '',
                };
            });
            // Sort the final array by the 'number' field
            combinedArray.sort((a, b) => a.number - b.number);
            setSurveyData(combinedArray);
        }
    }, [data]);
    const onSubmit = async () => {
        // 제출 진행 중이면 무시 — 더블클릭/이중 탭으로 인한 중복 POST 차단
        if (isSubmittingRef.current)
            return;
        isSubmittingRef.current = true;
        try {
            let submitData = [];
            const allowPartialSubmit = item?.type === '설문형';
            // 미작성 문항 판정: choice/checkbox=선택된 option 없음, short/long=data가 빈 문자열
            const hasEmpty = changeSurveyData.some(survey => {
                if (survey.type === 'choice' || survey.type === 'checkbox') {
                    return !survey.data.some(option => option.checked);
                }
                if (survey.type === 'short' || survey.type === 'long') {
                    return survey.data === '';
                }
                return false;
            });
            // 미작성 문항이 하나라도 있으면 확인 후 현 답변 상태로 제출, 취소 시 제출 중단
            if (hasEmpty) {
                if (!window.confirm('작성하지 않은 항목이 있습니다. 이대로 제출하시겠습니까?')) {
                    return;
                }
            }
            // 확인을 눌렀거나 설문형이면 미작성 문항을 빈 값으로 허용하여 제출
            const allowEmptyAnswer = allowPartialSubmit || hasEmpty;
            for (const survey of changeSurveyData) {
                if (survey.type === 'choice') {
                    const selectedOptions = survey.data.filter(option => option.checked);
                    if (selectedOptions.length === 0) {
                        if (!allowEmptyAnswer) {
                            alert('모든 항목에 답변해주세요.');
                            return;
                        }
                        submitData.push({
                            question_id: survey.id,
                            values: [''],
                        });
                        continue;
                    }
                    submitData.push({
                        question_id: survey.id,
                        values: selectedOptions.map(option => option.title),
                    });
                }
                if (survey.type === 'checkbox') {
                    const selectedOptions = survey.data.filter(option => option.checked);
                    if (selectedOptions.length === 0) {
                        if (!allowEmptyAnswer) {
                            alert('모든 항목에 답변해주세요.');
                            return;
                        }
                        submitData.push({
                            question_id: survey.id,
                            values: [''],
                        });
                        continue;
                    }
                    // push every single selected option as one data
                    selectedOptions.forEach(option => {
                        submitData.push({
                            question_id: survey.id,
                            values: [option.title],
                        });
                    });
                }
                if (survey.type === 'short' || survey.type === 'long') {
                    if (survey.data === '') {
                        if (!allowEmptyAnswer) {
                            alert('모든 항목에 답변해주세요.');
                            return;
                        }
                        submitData.push({
                            question_id: survey.id,
                            values: [''],
                        });
                        continue;
                    }
                    if (survey.data.length > 500) {
                        alert('장문형, 단답형은 500자 이내로 작성해주세요.');
                        return;
                    }
                    submitData.push({
                        question_id: survey.id,
                        values: [survey.data],
                    });
                }
            }
            if (submitData && submitData.length === 0 && !allowEmptyAnswer) {
                alert('모든 항목에 답변해주세요.');
                return;
            }
            await submitAnswerMutation.mutateAsync({
                id: test_id,
                props: {
                    answers: submitData,
                    subject_items: [],
                },
            });
            APP.eventManager.publish('ANSWER_REFETCH');
        }
        catch (error) {
            alert(error);
        }
        finally {
            // 성공/실패/검증 중단 모두에서 해제 — 이후의 정상 재제출 허용
            isSubmittingRef.current = false;
        }
    };
    return (react_1.default.createElement(DetailQuestionStyled, { "$isDesktop": isDesktop, "$isMobile": isMobile, "$isTablet": isTablet, "$isTeacher": isTeacher, className: "field-global-001 detail-question-wrap", style: { overflow: 'auto' } },
        react_1.default.createElement("div", { className: `flex column ${!isTeacher ? 'survey_wrapper' : 'survey_wrapper border'}` },
            !isSubmit && react_1.default.createElement("p", { className: "label" }, "\uC124\uBB38\uC5D0 \uCC38\uC5EC \uD574\uC8FC\uC138\uC694."),
            react_1.default.createElement(Survey_1.SurveyLayout, { surveyData: isSubmit ? submittedSurveyData : surveyData, isSubmit: item.status === 'closed' ? (isTeacher ? true : isSubmit) : isSubmit, isRegist: false, setSurveyData: setChangeSurveyData }),
            isTest
                ? null
                : !isMobile &&
                    isOpen &&
                    !isSubmit && (react_1.default.createElement("div", { className: "btn-container", style: { textAlign: 'right' } },
                    react_1.default.createElement(common_1.Button, { className: "btn_default xmd", text: "common.submit", onClick: onSubmit }))),
            isMobile && !isSubmit && (react_1.default.createElement("div", { className: "btn-container", style: { textAlign: 'right' } },
                react_1.default.createElement("div", { className: "submission-header" }, isTest
                    ? null
                    : isOpen &&
                        !isSubmit && (react_1.default.createElement(common_1.Button, { className: "btn_grey full", text: "common.submit", onClick: onSubmit }))))))));
});
